import styled from 'styled-components';

export const LocationsContainer = styled.div``;

export const LocationsBox = styled.div``;

export const LocationsTitle = styled.p`
    font-family: Poppins;
    font-size: 31px;
    font-weight: 700;
    line-height: 47px;
    letter-spacing: 0em;
    text-align: center;
    color: #0e4574;
    margin-top: 70px;
    margin-bottom: 20px;

    @media screen and (max-width: 600px) {
        line-height: 30px;
    }
`;

export const LocationsDescription = styled.p`
    font-family: Poppins;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: center;
    margin-top: 0;
`;

export const LocationsButton = styled.button`
    padding: 8px 20px;
    border-radius: 8px;
    font-family: Poppins;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: center;
    background: #a3c202;
    margin-top: 30px;
    margin-bottom: 50px;
    cursor: pointer;
    color: black;
`;

export const LocationsCards = styled.div`
    text-align: center;
    display: flex;
    justify-content: center;
    column-gap: 80px;
    margin-bottom: 40px;

    @media screen and (max-width: 600px) {
        flex-direction: column;
    }
`;

export const LocationsContent = styled.div`
    font-family: Poppins;
    text-align: left;
`;

export const LocationsCardTitle = styled.div`
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    color: #a3c202;
`;

export const LocationsAddress = styled.div`
    width: 55%;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
`;

export const LocationsNumber = styled.a`
    font-size: 16px;
    display:block;
    color:  #000000;
    text-decoration: unset;
`;

export const LocationsImage = styled.img`
    margin-top: 30px;
    width:100%;
    max-width: 430px;
    height: auto;
    display: block;
    margin-left: auto;
    margin-right: auto;
    object-fit:contain;

    @media screen and (max-width: 600px) {
        max-width: 100%;
    }
`;
